import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {reaction, observable} from "mobx";
import DataWrapper from '../../principal/containers/DataWrapper';
import {Tabela} from "../../comum/components/Tabela";
import {
    formatarCpf,
    formatarNomeProduto,
    motivoContratacaoFormatter,
    nullable,
    ordenarData,
    slaFormatter
} from "../../../utils/formatar";
import RascunhosStore from "../stores/RascunhosStore";
import {sortAlphaNum} from "../../../utils/ordenar";
import {ModalForm} from "../../comum/components/ModalForm";
import {Button} from 'reactstrap';

const COLUNAS = [
    {
        field: "id",
        label: "#",
        funcaoOrdenacao: sortAlphaNum.bind("id"),
    }, {
        field: "cargo",
        label: "Cargo"
    }, {
        field: "motivoContratacao",
        label: "Motivo de contratação",
        dataFormat: motivoContratacaoFormatter,
    }, {
        field: "justificativa",
        label: "Justificativa"
    }, {
        field: "nomeProduto",
        label: "Projeto/centro de resultado/finalidade",
        dataFormat: formatarNomeProduto
    }, {
        field: "dataInicio",
        label: "Data de início",
        funcaoOrdenacao: ordenarData.bind("dataInicio")
    }, {
        field: "dataFim",
        label: "Data de término",
        funcaoOrdenacao: ordenarData.bind("dataFim")
    }
];

@inject("store")
@DataWrapper
@observer
export class Rascunhos extends Component {
    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.modalStore = this.props.store.modalStore;
        /* Selecionar Controller */
        this.controller = new RascunhosStore();

        this.tituloPaginaStore.setBotoesMobile([
            {
                label: "Ordenar",
                icone: "sort",
                acao: () => this.modalStore.toggleModal('ordenar')
            }
        ]);
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Rascunhos");

        this.controller.carregarLista();

        /*TODO: caso for usar botões de ordenação de filtro
        this.tituloPaginaStore.setBotoesMobile([
            {
                label: "Ordenar",
                icone: "sort",
                acao: () => this.modalStore.toggleModal('ordenar')
            }
        ]);
        */
    }

    obterTituloMobile = (objeto) => {
        return  (objeto.id != null ? "#" + objeto.id : "");
    };



    obterConteudoMobile = (objeto) => {
        return (
            <div>
                { "Cargo: " +  nullable(objeto.cargo)}<br/>
                { "Motivo contratação: " + nullable(motivoContratacaoFormatter(objeto.motivoContratacao))}<br/>
                { "Justificativa: " + nullable(objeto.justificativa)}<br/>
                { "Projeto/centro de resultado/finalidade: " +  nullable(formatarNomeProduto(objeto.nomeProduto))}<br/>
                { "Data início: " + nullable(objeto.dataInicio)}<br/>
                { "Data término: " + nullable(objeto.dataFim)}<br/>
            </div>
        )
    };

    modalRender(){
        if(this.controller.modalOpen){
            return (
                <ModalForm
                    corpo={(
                        <div>
                            <span>Deseja realmente excluir os itens selecionados?</span>
                        </div>
                    )}
                    cabecalho={"Remover"}
                    botoes={(
                        <div>
                            <Button color="danger" onClick={() => {this.controller.removerSelecionados()}}>Remover</Button>
                            <Button color="secondary" onClick={() => {this.controller.fecharModal()}}>Cancelar</Button>
                        </div>
                    )}
                />
            );
        }
    }

    render() {
        const acoesItens = [{
            label: "Visualizar",
            icone: "search-plus",
            cor: "text-info",
            acao: "/nova-solicitacao-contratacao",
            parametros: ["id"]
        }];

        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel" : ""}>
                        <Tabela
                            keyField="id"
                            useCardsMobile={true}
                            temBusca={true}
                            habilitarSelecaoMultipla={true}
                            listaItens={this.controller.rascunhosLista}
                            colunaId={'id'}
                            colunas={COLUNAS}
                            acoesMultiplas={[{
                                label: "Remover",
                                icone: "trash",
                                acao: this.controller.abrirModal.bind(this.controller)
                            }]}
                            acoesItens={acoesItens}
                            tituloMobile={(row) => this.obterTituloMobile(row)}
                            conteudoMobile={(row) => this.obterConteudoMobile(row)}
                            onChange={(value) => this.controller.setLista(value)}
                            onCardClick={this.props.onCardClick}
                            loading={this.controller.loading}
                        />
                        {this.modalRender()}
                    </div>
                </div>
            </div>
        );
    }
}

